import { tenantApi } from '@shared/api/tenantApi';
import { unwrapList } from '@shared/api/unwrap';

export interface FaqEntry {
  faq_entry_id: string;
  question: string;
  answer: string;
  sort_order: number;
}

export interface FaqCategory {
  faq_category_id: string;
  name: string;
  description?: string | null;
  sort_order: number;
  entries: FaqEntry[];
}

interface RawFaqResponse {
  success?: boolean;
  data?: FaqCategory[];
}

export async function fetchFaqCategories(): Promise<FaqCategory[]> {
  const res = await tenantApi.get<RawFaqResponse>('/public/faq');
  return unwrapList<FaqCategory>(res.data);
}
